// extracted by mini-css-extract-plugin
export var cancelButton = "_op-5";
export var content = "_op-3";
export var createButton = "_op-6";
export var drawerContainer = "_op-0";
export var footer = "_op-2";
export var header = "_op-1";
export var orderFormColumn = "_op-4";